import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { TriangleAlert, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DraftErrorInfo } from "../hooks/parsePromoteErrors";

interface DraftPromoteErrorDialogProps {
  error: DraftErrorInfo | null;
  onClose: () => void;
}

const DraftPromoteErrorDialog: React.FC<DraftPromoteErrorDialogProps> = ({
  error,
  onClose,
}) => {
  const { t } = useTranslation("catalog-v2");
  const theme = useTheme();

  return (
    <Dialog
      open={!!error}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.backgroundCard,
          borderRadius: theme.spacing(2),
          border: `2px solid ${theme.palette.border}`,
          padding: theme.spacing(4),
          gap: theme.spacing(2.5),
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: 0,
        }}
      >
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{ color: theme.palette.exploreCardText, padding: 0 }}
        >
          <X size={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(2),
          padding: 0,
          color: theme.palette.exploreCardText,
        }}
      >
        <TriangleAlert size={48} />
        <Typography
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: theme.spacing(3),
            textAlign: "center",
          }}
        >
          {t("promote-dialog.title")}
        </Typography>
        <div>
          <Typography sx={{ fontSize: theme.spacing(2), textAlign: "center" }}>
            {t("promote-dialog.description")}
          </Typography>
          <Typography sx={{ fontSize: theme.spacing(2), textAlign: "center" }}>
            {t("promote-dialog.description-action")}
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DraftPromoteErrorDialog;
